addEventListener("DOMContentLoaded", () => {
    // JUDGE.ME App
    // Handling padding in the Judgme Review Width
    if (window.screen.width <= 680) {
        const reviewWidgetSection = document.querySelector(".jdgm-rev-widg");
        reviewWidgetSection.style.padding = "16px 16px";
    }
})